
import { defineComponent } from 'vue';
import './news-landing-hero.scss';
import { doItAll } from "./news-landing-hero-utils";
import { IFeaturedStory, ILoadedNewsLandingHeroData, INewsLandingHeroData } from './news-landing-hero-types';

/**
 * News landing hero organism
 * To display a news landing hero
 *
 * @example
 * <code>import TpxNewsLandingHero from "@manifesto-tech/tpximpact-design-system/components/organisms/news-landing-hero/news-landing-hero.vue";</code>
 */
export default defineComponent({
  name: 'TpxNewsLandingHero',
  props: {
    /**
     * Specify the page id (guid) of the News Landing Page for which you want to retrieve news
     */
    guid: {
      type: String,
      required: true,
    }
  },
  data(): INewsLandingHeroData {
    return {
      isLoading: false,
      hasErrored: false,
      featuredStories: new Array<IFeaturedStory>(),
      latestStories: new Array<IFeaturedStory>(),
    };
  },
  methods: {
    async loadData(): Promise<ILoadedNewsLandingHeroData | void> {
      this.isLoading = true;
      try {
        const data = await doItAll(this.guid);
        this.isLoading = false;
        //console.log("the final data", data);
        return data;
      } catch (error) {
        this.hasErrored = true;
        console.error('Error retrieving list data', error);
      }
    },

    formatDate(dateObj: Date): string {
      const options: Intl.DateTimeFormatOptions = { day: 'numeric', month: 'long', year: 'numeric' };
      return dateObj.toLocaleDateString("en-GB", options);
    }
  },

  async created() {
    const data = this.guid ? await this.loadData() : { featuredStories: [], latestStories: [] };
    //console.log('data', data)
    this.featuredStories = data?.featuredStories || [];
    this.latestStories = data?.latestStories || [];
  }
});
